var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7168 11.0297V13.0297C14.7175 13.2154 14.6795 13.3992 14.6051 13.5693C14.5307 13.7394 14.4216 13.8921 14.2848 14.0176C14.148 14.1432 13.9865 14.2387 13.8106 14.2982C13.6347 14.3577 13.4483 14.3798 13.2634 14.3631C11.212 14.1402 9.24142 13.4392 7.51009 12.3164C5.8993 11.2928 4.53364 9.92719 3.51009 8.31641C2.3834 6.57721 1.68225 4.59707 1.46342 2.53641C1.44676 2.35205 1.46867 2.16625 1.52775 1.99082C1.58684 1.8154 1.6818 1.6542 1.8066 1.51749C1.93139 1.38077 2.08329 1.27155 2.25261 1.19675C2.42194 1.12196 2.60498 1.08325 2.79009 1.08307H4.79009C5.11362 1.07989 5.42728 1.19446 5.67259 1.40543C5.91791 1.6164 6.07814 1.90937 6.12342 2.22974C6.20783 2.86978 6.36439 3.49822 6.59009 4.10307C6.67978 4.34169 6.69919 4.60102 6.64602 4.85033C6.59285 5.09964 6.46933 5.32848 6.29009 5.50974L5.44342 6.35641C6.39246 8.02544 7.77439 9.40737 9.44342 10.3564L10.2901 9.50974C10.4713 9.3305 10.7002 9.20697 10.9495 9.1538C11.1988 9.10063 11.4581 9.12004 11.6968 9.20974C12.3016 9.43544 12.93 9.59199 13.5701 9.67641C13.8939 9.72209 14.1897 9.88521 14.4011 10.1347C14.6125 10.3843 14.7249 10.7028 14.7168 11.0297Z",
    stroke: "#009CC5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallVector);
export default __webpack_public_path__ + "static/media/CallVector.2f7727fac6e3dfcfebf9fa2796323da8.svg";
export { ForwardRef as ReactComponent };